import React, { Component } from 'react';
import { AccountInfo } from '@azure/msal-browser';
import SignInPage from "./SignInPage";
import HomeRedirect from "./HomeRedirect";
import H from "history";
import {SchoolsCanAccessResponse} from "../../models/SchoolsCanAccessResponse";

interface WelcomePageProps {
    user: AccountInfo | undefined;
    history: H.History;
    schoolsCanAccess: SchoolsCanAccessResponse | undefined;
    userIsCdbEmployee: boolean
}

export default class WelcomePage extends Component<WelcomePageProps ,any> {
    static displayName = WelcomePage.name;
    
    constructor(props: WelcomePageProps) {
        super(props);
        
        this.state = {
            
        }
    }
    
    async componentDidMount() {
    }
    
    render () {
        
        if(this.props.user)
        {
            return <HomeRedirect userIsCdbEmployee={this.props.userIsCdbEmployee} schoolsCanAccess={this.props.schoolsCanAccess} history={this.props.history}/>
        }
        return (
            <SignInPage prompt={"To get started, sign in with your Microsoft Account"} thenRedirectTo={"/"}/>
        );
    }
}
